import { useEffect } from 'react'
import { StatusBar } from 'expo-status-bar'
import { createNativeStackNavigator } from '@react-navigation/native-stack'

// screens & components
import LoginScreen from '../screens/auth/LoginScreen'

// types
import { LoginParams } from '../types/authTypes'

const Stack = createNativeStackNavigator()

const AuthStack = ({ request, action }: LoginParams): JSX.Element => {
  const RenderLoginScreen = () => (
    <LoginScreen request={request} action={action} />
  )

  return (
    <>
      <Stack.Navigator
        initialRouteName="Login"
        screenOptions={{ headerShown: false, animation: 'fade_from_bottom' }}
      >
        <Stack.Screen
          options={{ headerShown: false }}
          name="Login"
          component={RenderLoginScreen}
        />
      </Stack.Navigator>
      <StatusBar style="dark" />
    </>
  )
}

export default AuthStack
